var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCompany(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.92 8.04H9.08a1 1 0 100 2h5.84a1 1 0 000-2zM14.92 14.82H9.08a1 1 0 100 2h5.84a1 1 0 000-2zM14.92 21.6H9.08a1 1 0 100 2h5.84a1 1 0 000-2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 29.5h-.75v-18a3 3 0 00-3-3h-5v-5a3 3 0 00-3-3h-13a3 3 0 00-3 3v26H2a1 1 0 000 2h28.5a1 1 0 000-2zm-10.75-21v21h-15v-26a1 1 0 011-1h13a1 1 0 011 1v5zm8 21h-6v-19h5a1 1 0 011 1v18z"
  })));
}

export default SvgCompany;